import GameSearchSelect from './GameSearchSelect';

export default GameSearchSelect;
